function IntroClaim(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var WORD_SHOW_DELAY = 250;
	
	
	/* PRIVATE VARIABLES */
	var mainText;
	var idea;
	var ideaLetters;
	var popup;
	var disabler;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	

	// TODO
	function animateWords(){
		var words = $('span.main-text b, span.idea');
		
		for (var i = 0; i < words.length; i++) {
			var word = $(words[i]);
			showWord(word, (i+1) * WORD_SHOW_DELAY);
		}
	}
	
	
	function showWord(word, delay){
		setTimeout(function () {
			word.addClass('visible');
		}, delay);
	}

	
	function initLetterInteraction(){
		ideaLetters.mouseover(function (e) {
			_this.container.addClass('idea-active');
			var letter = $(this);
			var letterText = letter.data('text');
			popup.text(letterText);
		});
		
		idea.mouseleave(function (e) {
			hidePopup();
		});
		
		disabler.click(function (e) {
			hidePopup()
		});
		
		popup.click(function (e) {
			hidePopup();
		});
		
		mainText.click(function (e) {
			hidePopup();
		});
	}
	
	function hidePopup(){
		_this.container.removeClass('idea-active');
	}
	
	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			mainText = $('span.main-text', _this.container);
			idea = $('span.idea', _this.container);
			popup = $('.popup', _this.container);
			ideaLetters = $('i', idea);
			disabler = $('section#intro .disabler');
			
			initLetterInteraction();
			animateWords();

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
